import { UIDynamicTable } from '../../components/table/ui-dynamic-table';
import { UIDynamicTableAbstractUITable } from '../../components/table/ui-dynamic-table.types';
import type { ComponentPlugin } from '../../components/ui-element.type';
import { rebuildChildren } from '../../global/ui-helpers';
import { UISortablePluginSortEventDetail } from './ui-sortable-plugin.type';

/**
 * @class
 * @classdesc Class for ui-dynamic-table pagination plugin.
 * @alias UIClientSortPlugin
 * @implements {ComponentPlugin}
 * @memberof {SharedComponents}
 */
export class UIClientSortPlugin implements ComponentPlugin {
    private readonly target: UIDynamicTable;

    constructor(target: UIDynamicTable) {
        this.target = target;
    }

    private handleSortTable = (e: Event): void => {
        const eventData = (e as CustomEvent)
            .detail as UISortablePluginSortEventDetail;
        this.target.sortDir = eventData.direction === 1 ? 'asc' : 'desc';
        this.target.sortOrder = eventData.column;

        const records = [...this.target._records];
        rebuildChildren(
            this.target.tbody,
            records
                .sort(this.target.buildCompareFn())
                .slice(
                    0,
                    this.target.limit > 0 ? this.target.limit : records.length
                )
                .map(this.target.buildTableRow.bind(this.target))
        );

        // if the table has invert plugin, then call its prepareLayout method
        const abstractUiTable = this.target
            .uiTable as UIDynamicTableAbstractUITable;
        if (typeof abstractUiTable.prepareLayout === 'function') {
            abstractUiTable.prepareLayout();
        }
    };

    /**
     * @inheritDoc
     */
    hydrate(): void {
        this.target.addEventListener(
            'sort-table',
            this.handleSortTable.bind(this)
        );
    }
}
